<template>
  <div :class="$style['delay']">
    <pt-sub-title title="批量延期交付">
    </pt-sub-title>

    <pt-form-item label="延期日期：" :labelWidth="labelWidth" :required="true">
      <el-date-picker v-model="form.delayDate" type="date" placeholder="选择日期" data-vv-as="延期日期"
        v-validate="'required'"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="延期原因：" :labelWidth="labelWidth" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.delayReason"
        :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native
        :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
    </pt-form-item>
    <pt-form-item label="备注：" :labelWidth="labelWidth">
      <el-input placeholder="请填写备注" v-model="form.comment" type="textarea"></el-input>
    </pt-form-item>
  </div>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'bill-delay',
  props: {
    billIds: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      labelWidth: '100px',
      form: {
        delayDate: '',
        delayReason: '',
        comment: ''
      },
      options: [
        '样品较多，正在进行中，需要延期',
        '缺失标准品或试剂',
        '仪器故障',
        '需要提供仪器配件、色谱柱等',
        '实验结果超标或不符合预期，需重新复测',
        '样品量不够，或样品本身不适用，需要重新寄样',
        '实验后发现方法不合适，需要客户重新提供方法',
        '未提供有效方法，实验需要时间摸索',
        '客户先确认电子数据结果，再进行后续实验或出原始记录',
        '实验员不能正常到岗，需要延期',
        '送至其他部门或外送，需要延期'
      ],
      reasonProps: {
        label: 'name',
        value: 'id'
      },
    }
  },
  watch: {
  },
  created() {
    // 组件创建时获取延期原因选项
    this.getDelayReasonOptions();
  },
  methods: {
    formValidata() {
      return validate(this, this.form)
    },
    // 获取延期原因选项
    getDelayReasonOptions() {
      // 使用与单个延期交付相同的API获取延期原因选项
      this.$store.dispatch('getAbnormalReason', 'DELAY_REASON').then(res => {
        // 只有当API返回数据时才更新options，否则保留默认选项
        if (res && res.length > 0) {
          this.options = res;
        }
      }).catch(err => {
        console.error('获取延期原因选项失败:', err);
        // 保留默认选项
      });
    },
    // 重置表单方法
    resetForm() {
      this.form = {
        delayDate: '',
        delayReason: '',
        comment: ''
      };
    }
  }
}
</script>
<style module lang="less">
.delay {
  :global {
    .el-select {
      width: 2.2rem;
    }
    .el-textarea,
    .el-textarea__inner {
      width: 3.2rem;
    }
  }
}
</style>
